import { ScriptService } from './script.service'

interface IYouTubeScriptService {
    loadYTIframeAPI: () => Promise<boolean>
}

export class YouTubeScriptService implements IYouTubeScriptService {
    private youtubeLoaded = false

    public async loadYTIframeAPI(): Promise<boolean> {
        // matching youtube instructions
        if (!window.onYouTubeIframeAPIReady) {
            // eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/explicit-function-return-type
            window.onYouTubeIframeAPIReady = () => {}
        }

        if (this.youtubeLoaded === false) {
            const firstScriptTag = document.getElementsByTagName('script')[0]
            if (firstScriptTag) {
                ScriptService.getInstance()
                    .loadScript({
                        name: 'youtubeIframeAPI',
                        src: 'https://www.youtube.com/iframe_api',
                        loaded: false
                    })
                    .catch((error: Error) => console.error(error))
            }
            this.youtubeLoaded = true
        }
        return this.youtubeLoaded
    }
}
